export default "__VITE_ASSET__4323c5f0__"